import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./shared";
import {
  Building2,
  CreditCard,
  FileText,
  LayoutDashboard,
  LogOut,
  MapPinned,
  Menu,
  ShieldCheck,
  Wrench,
  BookOpenCheck,
} from "lucide-react";
import { useState } from "react";

const NAVIGATION = [
  ["", LayoutDashboard, "Home"],
  ["profile", Building2, "Profile"],
  ["services", Wrench, "Services"],
  ["service-areas", MapPinned, "Service Areas"],
  ["documents", FileText, "Documents"],
  ["pilot-bookings", BookOpenCheck, "Pilot Bookings"],
  ["subscription", CreditCard, "Subscription"],
];

export default function VendorLayout() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-950">
      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6">
          <Logo />
          <div className="hidden items-center gap-3 sm:flex">
            <div className="text-right" data-testid="vendor-account-identity">
              <p className="text-sm font-semibold">{user?.name}</p>
              <p className="text-xs text-slate-500">Vendor Partner</p>
            </div>
            <button
              className="inline-flex h-9 w-9 items-center justify-center border border-slate-200 text-slate-600 transition-colors hover:bg-rose-50 hover:text-rose-700"
              data-testid="vendor-logout-button"
              onClick={logout}
              title="Sign out"
              type="button"
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
          <button
            aria-label="Toggle vendor navigation"
            className="inline-flex h-9 w-9 items-center justify-center border border-slate-200 sm:hidden"
            data-testid="vendor-mobile-menu-button"
            onClick={() => setOpen((value) => !value)}
            type="button"
          >
            <Menu className="h-5 w-5" />
          </button>
        </div>
        <nav
          className={`${open ? "block" : "hidden"} border-t border-slate-100 sm:block`}
          data-testid="vendor-mobile-navigation"
        >
          <div className="mx-auto flex max-w-7xl flex-col px-3 py-2 sm:flex-row sm:px-6">
            {NAVIGATION.map(([path, Icon, label]) => (
              <NavLink
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 text-sm font-medium transition-colors ${
                    isActive ? "bg-emerald-50 text-emerald-800" : "text-slate-600 hover:bg-slate-100"
                  }`
                }
                data-testid={`vendor-nav-${path || "home"}`}
                end={path === ""}
                key={path}
                onClick={() => setOpen(false)}
                to={`/vendor/${path}`}
              >
                <Icon className="h-4 w-4" />
                {label}
              </NavLink>
            ))}
            <button
              className="flex items-center gap-2 px-3 py-2 text-left text-sm font-medium text-rose-700 sm:hidden"
              data-testid="vendor-mobile-logout-button"
              onClick={logout}
              type="button"
            >
              <LogOut className="h-4 w-4" />
              Sign out
            </button>
          </div>
        </nav>
      </header>
      <main className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:py-10">
        <Outlet />
      </main>
      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl items-center gap-2 px-4 py-4 text-xs text-slate-500 sm:px-6">
          <ShieldCheck className="h-4 w-4 text-emerald-700" />
          Vendor business and verification information is visible only to authorized MySocietyMitra staff.
        </div>
      </footer>
    </div>
  );
}